import { accountPageGamesModel } from 'pages/account-page/model';
import { createBlockGameModal } from 'features/block-game';
import { createUnblockGameModal } from 'features/unblock-game';
import { createGameRegistry } from 'entities/game';
import cls from './account-page-games.module.scss';

const GameRegistry = createGameRegistry(accountPageGamesModel.gameRegistryModel);

const BlockGameModal = createBlockGameModal(accountPageGamesModel.blockGameModel);

const UnblockGameModal = createUnblockGameModal(accountPageGamesModel.unblockGameModel);

export const AccountPageGames = () => (
	<>
		<GameRegistry
			withTitle={false}
			withAccount={false}
			className={cls.accountPageGamesRegistry}
			tableTdActionSlot={(game) => (
				<div className={cls.accountPageGamesActions}>
					{game.isLocked ? (
						<UnblockGameModal.ActionIcon modalData={game} />
					) : (
						<BlockGameModal.ActionIcon modalData={game} />
					)}
				</div>
			)}
		/>
		<BlockGameModal />
		<UnblockGameModal />
	</>
);
